/**
 * Shared formatting utilities — import from here instead of defining locally.
 * Usage: import { fmtAmt, fmtFull, fmtCompact } from '@/utils/format';
 */

/**
 * Smart Indian currency format:
 * ≥ 1 Cr  → ₹1.49 Cr
 * ≥ 1 L   → ₹14.9L
 * ≥ 1 K   → ₹14.9K
 * else    → ₹999
 */
export function fmtAmt(n) {
  const abs  = Math.abs(n || 0);
  const sign = (n || 0) < 0 ? '-' : '';
  if (abs >= 10000000) return `${sign}₹${(abs / 10000000).toFixed(2)} Cr`;
  if (abs >= 100000)   return `${sign}₹${(abs / 100000).toFixed(1)}L`;
  if (abs >= 1000)     return `${sign}₹${(abs / 1000).toFixed(1)}K`;
  return `${sign}₹${Math.round(abs).toLocaleString('en-IN')}`;
}

/**
 * Full Indian number format — no abbreviation.
 * 14994117 → ₹1,49,94,117
 */
export function fmtFull(n) {
  if (!n && n !== 0) return '₹0';
  const sign = n < 0 ? '-' : '';
  return `${sign}₹${Math.abs(Math.round(n)).toLocaleString('en-IN')}`;
}

/**
 * Compact format without ₹ sign — for use inside labels.
 * 14994117 → 1.49 Cr
 */
export function fmtCompact(n) {
  return fmtAmt(n).replace('₹', '').trim();
}

/**
 * Percentage — always 1 decimal place.
 * 0.1234 → 12.3%
 */
export function fmtPct(n, alreadyPct = false) {
  const val = alreadyPct ? (n || 0) : (n || 0) * 100;
  return `${val.toFixed(1)}%`;
}
